export enum Codes {
    SUCCESS,

    PERMISSION_DENIED,

    UNREGISTERED,
    REGISTERED,

    /* Account */
    PHONE_NUMBER_INVALID,
    PASSWORD_INVALID,
    VERIFICATION_CODE_INVALID,
    REQUIRED_VERIFICATION_CODE,
    REQUIRED_PASSWORD,
}


export const defaultMessages: Record<string, string> = {
    UNKNOWN_ERROR: 'error occurred',

    SUCCESS: 'success',

    PERMISSION_DENIED: 'permission denied',

    UNREGISTERED: 'account is not registered',
    REGISTERED: 'account is already registered',

    /* Account */
    PHONE_NUMBER_INVALID: 'phone number is invalid',
    PASSWORD_INVALID: 'password is invalid',
    VERIFICATION_CODE_INVALID: 'verification code is invalid',
    REQUIRED_VERIFICATION_CODE: 'verification code is required',
    REQUIRED_PASSWORD: 'password is required',
}